module.exports = __webpack_public_path__ + "static/media/spinach.d39cb219.jpg";